
function Results() {
  return <h1>result component</h1>
}

export default Results